/**
 * The beta, as one switch.
 *
 * Chompdome ships changes constantly right now, and a player who finds the arena rearranged
 * between two sessions should have been told to expect that. Every surface that says so — the
 * strip under the site header and the badge in the game's HUD — reads this module and nothing
 * else, so the day the beta ends is one edit: `BETA_ENABLED = false`, and both disappear.
 *
 * A constant rather than an env variable on purpose. There is no configuration to get wrong,
 * nothing to forget in a deploy, and Vite drops the dead branches out of the bundle.
 */

/** The one line to change when the beta is over. */
export const BETA_ENABLED = true;

/** What the badge says, in both places, so the two are never one word apart. */
export const BETA_LABEL = 'Beta';

/** The full sentence, for the site strip and the HUD badge's tooltip. */
export const BETA_NOTICE = 'Chompdome is in beta — expect frequent changes while we ship updates.';

/**
 * The phone half of the same sentence. Swapped by a breakpoint rather than measured, so the
 * strip is one line at every width and never reflows the page under it.
 */
export const BETA_NOTICE_SHORT = 'Expect frequent changes.';

/**
 * The surface both beta notices are drawn on, and the whole of "it is not translucent".
 *
 * A player reported the strip merging with the text scrolling behind it, which is what a 10%
 * accent fill over whatever happens to be under it does — the fill tints, it does not cover. So
 * the pair moved to `.beta-surface` (`app.css`): an OPAQUE colour, `--color-accent` mixed into
 * `--color-card`, which keeps the accent tint the strip is recognised by and still hides
 * everything behind it. Both tokens are theme-aware, so one rule is solid in dark and in light.
 *
 * Shared from here rather than repeated because the two surfaces are one feature — this module's
 * whole reason — and because the badge in the arena is the same sentence over a *moving*
 * background, which is the harder version of the same problem. It is the one HUD panel that is
 * not `HUD_PANEL_CLASS`: every other panel is translucent so a pellet behind it can still be
 * seen, and this one is the exception the report asked for.
 */
export const BETA_SURFACE_CLASS = 'beta-surface';
